import client from './client'

/**
 * @param {string} [category]  Optional event-type slug for server-side filtering.
 *                             Omit (or pass '') to fetch all gallery items.
 */
export const fetchGallery = (category = '') =>
  client.get('/gallery', category ? { params: { category } } : undefined)
